import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// assets
import Ellipse1 from '../../../../images/product-assets/Ellipse1.svg';
import Ellipse2 from '../../../../images/product-assets/Ellipse2.svg';
import Check from '../../../../images/product-assets/round_check.svg';

const Container = styled.section`
    position: relative;
    overflow: hidden;
`;

const ContentBox = styled.div`
    z-index: 1;
    max-width: 1280px;
    margin: 0 auto;
    padding: 100px 20px 0;
    display: grid;
    grid-template-areas:
        'heading graphic'
        'description graphic';
    grid-template-rows: fit-content auto;
    grid-template-columns: 1fr 1fr;
    column-gap: 60px;

    @media screen and (max-width: 500px) {
        padding: 54px 16px 0;
        grid-template-areas:
            'heading heading'
            'graphic graphic'
            'description description';
    }
`;

const Heading = styled.h1`
    color: #333;
    font-size: 40px;
    font-weight: 500;
    line-height: 47px;
    grid-area: heading;

    @media screen and (max-width: 500px) {
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        margin-bottom: 36px;
    }
`;

const DescriptionSection = styled.div`
    grid-area: description;
    margin-top: 14px;

    @media screen and (max-width: 500px) {
        margin-top: 28px;
    }
`;

const Description = styled.p`
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    color: #52525b;

    @media screen and (max-width: 500px) {
        font-size: 14px;
        line-height: 18px;
        text-align: center;
    }
`;

const Divider = styled.hr`
    margin-top: 28px;
    border: 1px solid #e7eaee;
    width: 80%;

    @media screen and (max-width: 500px) {
        width: 100%;
    }
`;

const ListGroup = styled.div`
    background-color: #fff;
    margin-top: 24px;
    display: flex;
    gap: 16px;
    flex-direction: column;
`;

const List = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
`;

const Icon = styled.img`
    width: 32px;
    height: 32px;
`;

const Label = styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    color: #333;
`;

const GraphicSection = styled.div`
    grid-area: graphic;
    background-color: #fff;
`;

const Graphic = styled.img`
    width: 100%;
`;

const EllipseOne = styled.img`
    position: absolute;
    left: -5%;
    bottom: 0;
    z-index: -1;

    @media screen and (max-width: 500px) {
        display: none;
    }
`;

const EllipseTwo = styled.img`
    position: absolute;
    right: -5%;
    top: 15%;
    z-index: -1;

    @media screen and (max-width: 500px) {
        display: none;
    }
`;

function SecondaryInfoSection({ title, desc1, desc2, bulletPoints, sectionImage }) {
    return (
        <Container id="SecondaryInfoSection">
            <ContentBox>
                <Heading>{title}</Heading>
                <DescriptionSection>
                    <Description>
                        {desc1}
                        <br />
                        <br />
                        {desc2}
                    </Description>
                    <Divider />
                    <ListGroup>
                        {bulletPoints?.map((points) => (
                            <List key={points.id}>
                                <Icon src={Check} alt="check mark" />
                                <Label>{points.label}</Label>
                            </List>
                        ))}
                    </ListGroup>
                </DescriptionSection>
                <GraphicSection>
                    <Graphic src={sectionImage} alt="Section information graphic" />
                </GraphicSection>
            </ContentBox>
            <EllipseOne src={Ellipse1} alt="Ellipse 1" />
            <EllipseTwo src={Ellipse2} alt="Ellipse 2" />
        </Container>
    );
}

SecondaryInfoSection.propTypes = {
    title: PropTypes.string,
    desc1: PropTypes.string,
    desc2: PropTypes.string,
    bulletPoints: PropTypes.array,
    sectionImage: PropTypes.string,
};

export default SecondaryInfoSection;
